export default "__VITE_ASSET__BSBAPECX__"